import {addBudgetToTicket, BudgetDto} from "../../services/Supervisor/ticketService";
import {useState} from "react";

export const useAddBudget = () => {

    const [addingBudget, setAddingBudget] = useState(false)

    const addBudget = async (ticketUniqueCode: string, budgetList: BudgetDto[]) => {
        setAddingBudget(true)
        try {
            await addBudgetToTicket(ticketUniqueCode, budgetList)
        } catch (error) {
            console.error('Error adding budget:', error);
            throw error;
        } finally {
            setTimeout(() => setAddingBudget(false), 600)
        }
    }

    return { addBudget, addingBudget };
};
